var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"g-backtop"},[_c('BackTop',{attrs:{"height":800,"right":50,"bottom":175}},[_c('div',{staticClass:"top"},[_c('img',{attrs:{"src":require("./img/top.png")}})])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }